import { render, staticRenderFns } from "./KnowledgeArticles.vue?vue&type=template&id=39576e9a&lang=pug"
import script from "./KnowledgeArticles.vue?vue&type=script&lang=js"
export * from "./KnowledgeArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports